export const fieldImages = [
    {
        label: 'گردنبند و آویز',
        value: 'https://img.icons8.com/external-flatart-icons-lineal-color-flatarticons/96/undefined/external-necklace-brazilian-carnival-flatart-icons-lineal-color-flatarticons.png',
    },
    {
        label: 'انگشتر',
        value: 'https://img.icons8.com/doodle/96/undefined/ring-front-view--v1.png',
    },
    {
        label: 'ست و نیم‌ست',
        value: 'https://img.icons8.com/external-dreamcreateicons-fill-lineal-dreamcreateicons/96/undefined/external-necklace-museum-dreamcreateicons-fill-lineal-dreamcreateicons.png',
    },
    {
        label: 'دستبند',
        value: 'https://img.icons8.com/external-soft-fill-juicy-fish/96/undefined/external-bracelet-clothing-and-accessories-soft-fill-soft-fill-juicy-fish.png',
    },
    {
        label: 'گوشواره',
        value: 'https://img.icons8.com/external-vitaliy-gorbachev-flat-vitaly-gorbachev/96/undefined/external-earrings-mother-day-vitaliy-gorbachev-flat-vitaly-gorbachev.png',
    },
    {
        label: 'النگو',
        value: 'https://img.icons8.com/officel/96/undefined/bangles.png',
    },
    {
        label: 'ساعت',
        value: 'https://img.icons8.com/emoji/96/undefined/watch-emoji.png',
    },
    {
        label: 'اکسسوری',
        value: 'https://img.icons8.com/external-smashingstocks-hand-drawn-color-smashing-stocks/96/undefined/external-accessory-travel-vacation-smashingstocks-hand-drawn-color-smashing-stocks.png',
    },
    {
        label: 'مشاوره پزشکی',
        value: 'https://img.icons8.com/color/96/undefined/doctor-giving-advice.png',
    },
    {
        label: 'مشاوره روانشناسی',
        value: 'https://img.icons8.com/external-flaticons-lineal-color-flat-icons/96/undefined/external-psychological-mental-health-flaticons-lineal-color-flat-icons-2.png',
    },
    {
        label: ' آزمایش در محل',
        value: 'https://img.icons8.com/color/96/undefined/pcr-test--v1.png',
    },
    {
        label: 'خدمات پزشکی در محل',
        value: 'https://img.icons8.com/color/96/undefined/doctors-bag.png',
    },
    {
        label: 'تجهیزات پزشکی خانگی',
        value: 'https://img.icons8.com/external-flaticons-lineal-color-flat-icons/96/undefined/external-medical-equipment-nursing-flaticons-lineal-color-flat-icons.png',
    },
    {
        label: 'مادر و کودک',
        value: 'https://img.icons8.com/cute-clipart/96/undefined/mommy-and-me-classes.png',
    },
    {
        label: 'لوازم آرایشی و بهداشتی',
        value: 'https://img.icons8.com/fluency/96/undefined/makeup.png',
    },
    {
        label: 'خوراکی‌های رژیمی',
        value: 'https://img.icons8.com/external-flaticons-lineal-color-flat-icons/96/undefined/external-diet-lifestyles-flaticons-lineal-color-flat-icons-2.png',
    },
    {
        label: 'آموزش همکاری در فروش',
        value: 'https://img.icons8.com/color/96/000000/teaching.png',
    },
    {
        label: 'آموزش فریلنسینگ جهانی',
        value: 'https://img.icons8.com/external-flat-juicy-fish/96/000000/external-freelancing-side-hustles-flat-flat-juicy-fish.png',
    },
    {
        label: 'راه و روش‌های کسب درآمد از آمازون',
        value: 'https://img.icons8.com/doodle/96/000000/money.png',
    },
    {
        label: 'آموزش اصول راه اندازی بیزینس آنلاین موفق',
        value: 'https://img.icons8.com/external-xnimrodx-lineal-color-xnimrodx/96/000000/external-online-business-freelancer-xnimrodx-lineal-color-xnimrodx.png',
    },
    {
        label: 'دفتر کار مجازی',
        value: 'https://img.icons8.com/color/96/000000/office.png',
    },
    {
        label: 'تلفن گویای هوشمند',
        value: 'https://img.icons8.com/nolan/96/shake-phone.png',
    },
    {
        label: 'تلفن اینترنتی',
        value: 'https://img.icons8.com/stickers/96/000000/sip-dialer.png',
    },
    {
        label: 'لباس ورزشی مردانه',
        value: 'https://img.icons8.com/plasticine/96/000000/swimming-cap.png',
    },
    {
        label: 'لباس ورزشی زنانه',
        value: 'https://img.icons8.com/cotton/96/000000/school-uniform.png',
    },
    {
        label: 'قمقمه و جاگر',
        value: 'https://img.icons8.com/external-vitaliy-gorbachev-lineal-color-vitaly-gorbachev/96/000000/external-thermos-camping-vitaliy-gorbachev-lineal-color-vitaly-gorbachev.png',
    },
    {
        label: 'تغذیه رژیمی',
        value: 'https://img.icons8.com/external-flaticons-flat-flat-icons/96/000000/external-diet-lifestyles-flaticons-flat-flat-icons-3.png',
    },
    {
        label: 'لوازم ورزشی',
        value: 'https://img.icons8.com/color/96/000000/sports.png',
    },
    {
        label: 'اکسسوری‌های ورزشی',
        value: 'https://img.icons8.com/cotton/96/000000/cap--v4.png',
    },
    {
        label: 'بهداشت و سلامت پوست',
        value: 'https://img.icons8.com/external-flaticons-lineal-color-flat-icons/96/000000/external-skin-cbd-oil-flaticons-lineal-color-flat-icons-2.png',
    },
    {
        label: 'بهداشت و سلامت مو',
        value: 'https://img.icons8.com/color-glass/96/000000/skin.png',
    },
    {
        label: 'بهداشت و مراقبت جنسی',
        value: 'https://img.icons8.com/cotton/96/000000/condom--v1.png',
    },
    {
        label: 'بهداشت و مراقبت دهان و دندان',
        value: 'https://img.icons8.com/cotton/96/000000/blowjob--v1.png',
    },
    {
        label: 'محصولات بهداشتی بانوان',
        value: 'https://img.icons8.com/color/96/000000/pad.png',
    },
    {
        label: 'استارتاپ',
        value: 'https://img.icons8.com/external-justicon-flat-justicon/96/000000/external-startup-ecommerce-justicon-flat-justicon.png',
    },
    {
        label: 'بازاریابی',
        value: 'https://img.icons8.com/cotton/96/000000/web-marketing.png',
    },
    {
        label: 'فناوری اطلاعات',
        value: 'https://img.icons8.com/stickers/96/000000/device-information.png',
    },
    {
        label: 'مالی',
        value: 'https://img.icons8.com/nolan/96/check-dollar.png',
    },
    {
        label: 'توسعه فردی',
        value: 'https://img.icons8.com/color/96/000000/personal-trainer-skin-type-1.png',
    },
    {
        label: 'روانشناسی',
        value: 'https://img.icons8.com/external-smashingstocks-circular-smashing-stocks/96/000000/external-psychology-technology-and-hardware-smashingstocks-circular-smashing-stocks.png',
    },
    {
        label: 'حقوقی',
        value: 'https://img.icons8.com/external-icongeek26-linear-colour-icongeek26/96/000000/external-legal-business-and-finance-icongeek26-linear-colour-icongeek26.png',
    },
    {
        label: 'هنری',
        value: 'https://img.icons8.com/external-microdots-premium-microdot-graphic/96/000000/external-artistic-sport-fitness-vol2-microdots-premium-microdot-graphic-2.png',
    },
    {
        label: 'و ...',
        value: 'https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/96/000000/external-more-multimedia-kiranshastry-lineal-color-kiranshastry.png',
    },
    {
        label: 'وسایل دیجیتال',
        value: 'https://img.icons8.com/fluency/96/000000/electronics.png',
    },
    {
        label: 'پوشاک',
        value: 'https://img.icons8.com/office/96/000000/clothes.png',
    },
    {
        label: 'لوازم آرایشی و بهداشتی',
        value: 'https://img.icons8.com/external-edtim-lineal-color-edtim/96/000000/external-Cosmetics-home-edtim-lineal-color-edtim-4.png',
    },
    {
        label: 'لوازم ورزشی',
        value: 'https://img.icons8.com/color/96/000000/sports.png',
    },
    {
        label: 'محصولات سلامت',
        value: 'https://img.icons8.com/dusk/96/000000/apple-health.png',
    },
    {
        label: 'انواع مکمل‌های ورزشی',
        value: 'https://img.icons8.com/color/96/000000/sports.png',
    },
    {
        label: 'مکمل‌های تقویتی',
        value: 'https://img.icons8.com/external-xnimrodx-lineal-color-xnimrodx/96/000000/external-supplement-fitness-and-diet-xnimrodx-lineal-color-xnimrodx.png',
    },
    {
        label: 'محصولات مادر و کودک',
        value: 'https://img.icons8.com/office/96/000000/mother.png',
    },
    {
        label: 'محصولات بهداشتی',
        value: 'https://img.icons8.com/external-flaticons-flat-flat-icons/96/000000/external-sanitary-digital-nomad-flaticons-flat-flat-icons.png',
    },
    {
        label: 'مراقبت از پوست و مو',
        value: 'https://img.icons8.com/external-others-ghozy-muhtarom/96/000000/external-skin-organic-cosmetic-filled-line-others-ghozy-muhtarom-2.png',
    },
    {
        label: 'محصولات آرایشی',
        value: 'https://img.icons8.com/office/96/000000/face-powder.png',
    },
    {
        label: 'محصولات بهداشتی',
        value: 'https://img.icons8.com/external-wanicon-flat-wanicon/96/000000/external-sanitary-cleaning-wanicon-flat-wanicon.png',
    },
    {
        label: 'محصولات پوست و مو',
        value: 'https://img.icons8.com/external-flaticons-lineal-color-flat-icons/96/000000/external-hair-hairdresser-and-barber-shop-flaticons-lineal-color-flat-icons-3.png',
    },
    {
        label: 'محصولات بانوان',
        value: 'https://img.icons8.com/external-sbts2018-lineal-color-sbts2018/96/000000/external-women-womens-day-sbts2018-lineal-color-sbts2018.png',
    },
    {
        label: 'محصولات آقایان',
        value: 'https://img.icons8.com/external-filled-outline-berkahicon/96/000000/external-Men-solidarity-filled-outline-berkahicon.png',
    },
    {
        label: 'پوشاک مردانه',
        value: 'https://img.icons8.com/doodle/96/000000/user-male--v1.png',
    },
    {
        label: 'پوشاک زنانه',
        value: 'https://img.icons8.com/doodle/96/000000/user-female-red-hair.png',
    },
    {
        label: 'پوشاک دخترانه',
        value: 'https://img.icons8.com/doodle/96/000000/girl.png',
    },
    {
        label: 'پوشاک پسرانه',
        value: 'https://img.icons8.com/doodle/96/000000/boy.png',
    },
    {
        label: 'لوازم التحریر فانتزی',
        value: 'https://img.icons8.com/doodle/96/000000/teaching.png',
    },
    {
        label: 'اکسسوری منزل فانتزی',
        value: 'https://img.icons8.com/external-smashingstocks-hand-drawn-color-smashing-stocks/96/undefined/external-accessory-travel-vacation-smashingstocks-hand-drawn-color-smashing-stocks.png',
    },
    {
        label: 'قطعات و لوازم کامپیوتر',
        value: 'https://img.icons8.com/bubbles/96/000000/this-pc.png',
    },
    {
        label: 'موبایل و تبلت',
        value: 'https://img.icons8.com/office/96/000000/iphone-x.png',
    },
    {
        label: 'ماشین‌های اداری',
        value: 'https://img.icons8.com/office/96/000000/fax.png',
    },
    {
        label: 'لوازم و تجهیزات ماینینگ',
        value: 'https://img.icons8.com/office/96/000000/bitcoin.png',
    },
    {
        label: 'مودم و تجهیزات شبکه',
        value: 'https://img.icons8.com/external-smashingstocks-circular-smashing-stocks/96/000000/external-modem-technology-and-hardware-smashingstocks-circular-smashing-stocks.png',
    },
    {
        label: 'لوازم صوتی و تصویری',
        value: 'https://img.icons8.com/color/96/000000/tv.png',
    },
    {
        label: 'تجهیزات گیمینگ',
        value: 'https://img.icons8.com/external-anggara-flat-anggara-putra/96/000000/external-game-computer-device-anggara-flat-anggara-putra.png',
    },
    {
        label: 'مقنعه',
        value: 'https://img.icons8.com/external-filled-outline-berkahicon/96/000000/external-avatar-ramadan-filled-outline-berkahicon.png',
    },
    {
        label: 'چادر',
        value: 'https://img.icons8.com/external-filled-outline-berkahicon/96/000000/external-al-eid-al-fitr-filled-outline-berkahicon-9.png',
    },
    {
        label: 'محصولات چرم مردانه',
        value: 'https://img.icons8.com/external-filled-line-andi-nur-abdillah/96/000000/external-Leather-sewing-(filed-line)-filled-line-andi-nur-abdillah.png',
    },
    {
        label: 'محصولات چرم زنانه',
        value: 'https://img.icons8.com/ios/96/000000/bag-front-view.png',
    },
    {
        label: 'جوراب',
        value: 'https://img.icons8.com/color-glass/96/000000/pair-of-socks.png',
    },
    {
        label: 'زیورآلات مسی',
        value: 'https://img.icons8.com/office/96/000000/jewelry.png',
    },
    {
        label: 'صنایع دستی',
        value: 'https://img.icons8.com/external-outline-berkahicon/96/000000/external-clay-linely-pottery-outline-berkahicon-22.png',
    },
    {
        label: 'رزرو مجموعه‌های ورزشی',
        value: 'https://img.icons8.com/office/96/null/performance--v1.png',
    },
    {
        label: 'ثبت‌نام کلاس‌های ورزشی',
        value: 'https://img.icons8.com/color/96/null/sports.png',
    },
    {
        label: 'محصولات مراقبت از پوست و مو',
        value: 'https://img.icons8.com/external-victoruler-flat-victoruler/96/null/external-skin-internal-human-organs-victoruler-flat-victoruler.png',
    },
    {
        label: 'محصولات مراقبت از بدن',
        value: 'https://img.icons8.com/external-flaticons-lineal-color-flat-icons/96/null/external-body-care-tattoo-flaticons-lineal-color-flat-icons.png',
    },
    {
        label: 'محصولات مادر و کودک',
        value: 'https://img.icons8.com/color/96/null/woman-with-baby.png',
    },
    {
        label: 'محصولات دهان و دندان',
        value: 'https://img.icons8.com/fluency/96/null/tooth-cleaning-kit.png',
    },
    {
        label: 'عطر و ادکلن',
        value: 'https://img.icons8.com/color/96/null/perfume-bottle.png',
    },
    {
        label: 'درگاه پرداخت اینترنتی',
        value: 'https://img.icons8.com/color/96/null/card-in-use.png',
    },
    {
        label: 'کالای خواب',
        value: 'https://img.icons8.com/external-others-pike-picture/96/null/external-Bedsheet-sericulture-others-pike-picture.png',
    },
    {
        label: 'اقامت',
        value: 'https://img.icons8.com/external-jumpicon-line-ayub-irawan/96/EAB206/external-residence-real-estate-jumpicon-line-jumpicon-line-ayub-irawan.png',
    },
    {
        label: 'مهاجرت',
        value: 'https://img.icons8.com/external-filled-outline-wichaiwi/96/null/external-immigration-ageing-society-filled-outline-wichaiwi.png',
    },
    {
        label: 'ویزا',
        value: 'https://img.icons8.com/arcade/96/null/entrance-visa.png',
    },
    {
        label: 'محصولات مراقبت از پوست و مو',
        value: 'https://img.icons8.com/external-victoruler-flat-victoruler/96/null/external-skin-internal-human-organs-victoruler-flat-victoruler.png',
    },
    {
        label: 'محصولات مراقبت از بدن',
        value: 'https://img.icons8.com/external-flaticons-lineal-color-flat-icons/96/null/external-body-care-tattoo-flaticons-lineal-color-flat-icons.png',
    },
    {
        label: 'محصولات مادر و کودک',
        value: 'https://img.icons8.com/color/96/null/woman-with-baby.png',
    },
    {
        label: 'محصولات دهان و دندان',
        value: 'https://img.icons8.com/fluency/96/null/tooth-cleaning-kit.png',
    },
    {
        label: 'محصولات آرایشی',
        value: 'https://img.icons8.com/office/96/000000/face-powder.png',
    },
    {
        label: 'انواع مکمل‌های ورزشی',
        value: 'https://img.icons8.com/color/96/000000/sports.png',
    },
    {
        label: 'مکمل‌های تقویتی',
        value: 'https://img.icons8.com/external-xnimrodx-lineal-color-xnimrodx/96/000000/external-supplement-fitness-and-diet-xnimrodx-lineal-color-xnimrodx.png',
    },
    {
        label: 'محصولات مادر و کودک',
        value: 'https://img.icons8.com/office/96/000000/mother.png',
    },
    {
        label: 'محصولات بهداشتی',
        value: 'https://img.icons8.com/external-flaticons-flat-flat-icons/96/000000/external-sanitary-digital-nomad-flaticons-flat-flat-icons.png',
    },
    {
        label: 'مراقبت از پوست و مو',
        value: 'https://img.icons8.com/external-others-ghozy-muhtarom/96/000000/external-skin-organic-cosmetic-filled-line-others-ghozy-muhtarom-2.png',
    },
    {
        label: 'لپتاپ و لوازم جانبی',
        value: 'https://img.icons8.com/fluency/96/000000/mac-book-air.png',
    },
    {
        label: 'موبایل و تبلت',
        value: 'https://img.icons8.com/office/96/000000/iphone-x.png',
    },
    {
        label: 'ماشین‌های اداری',
        value: 'https://img.icons8.com/office/96/000000/fax.png',
    },
    {
        label: 'زیبایی و سلامت',
        value: 'https://img.icons8.com/fluency/96/null/face-powder.png',
    },
    {
        label: 'مودم و تجهیزات شبکه',
        value: 'https://img.icons8.com/external-smashingstocks-circular-smashing-stocks/96/000000/external-modem-technology-and-hardware-smashingstocks-circular-smashing-stocks.png',
    },
    {
        label: 'لوازم صوتی و تصویری',
        value: 'https://img.icons8.com/color/96/000000/tv.png',
    },
    {
        label: 'تجهیزات گیمینگ',
        value: 'https://img.icons8.com/external-anggara-flat-anggara-putra/96/000000/external-game-computer-device-anggara-flat-anggara-putra.png',
    },
]

export const benefitBgs = [
    {
        label: 'سبز',
        value: 'bg-green',
        color: '#21a29b',
    },
    {
        label: 'زرد',
        value: 'bg-yellow',
        color: '#ffc188',
    },
    {
        label: 'قرمز',
        value: 'bg-red',
        color: '#fe6587',
    },
    {
        label: 'بنفش',
        value: 'bg-purple',
        color: '#847ff2',
    },
    {
        label: 'آبی',
        value: 'bg-blue',
        color: '#9fbcfc',
    },
    {
        label: 'سبز روشن',
        value: 'bg-light-green',
        color: '#7be3b0',
    }
]

export const benefitIcons = [
    {
        label: 'کیفیت بالا',
        value: 'fa-brands fa-gratipay',
    },
    {
        label: 'شناخته بودن',
        value: 'fa-regular fa-face-grin-stars',
    },
    {
        label: 'ضمانت',
        value: 'fa-solid fa-certificate',
    },
    {
        label: 'دامنه همکاران',
        value: 'fa-solid fa-handshake',
    },
    {
        label: 'تنوع محصولی بالا',
        value: 'fa-solid fa-star',
    },
    {
        label: 'ارسال به سراسر کشور',
        value: 'fa-solid fa-dolly',
    },
    {
        label: 'صرفه‌جویی در زمان و هزینه',
        value: 'fa-solid fa-clock',
    },
    {
        label: 'مشاوره با پزشکان متعهد',
        value: 'fa-solid fa-user-doctor',
    },
    {
        label: 'تسهیل ارتباطات و افزایش درآمد',
        value: 'fa-solid fa-tower-broadcast',
    },
    {
        label: 'صرفه‌جویی در هزینه‌ها',
        value: 'fa-solid fa-circle-dollar-to-slot',
    },
    {
        label: '7 روز ضمانت بازگشت وجه',
        value: 'fa-solid fa-rotate-left',
    },
    {
        label: 'مدرس‌های حرفه‌ای',
        value: 'fa-solid fa-user-tie',
    },
    {
        label: 'تعرفه‌های مناسب',
        value: 'fa-solid fa-money-bill',
    },
    {
        label: 'دسته‌بندی‌های متنوع',
        value: 'fa-solid fa-shopping-cart',
    },
    {
        label: 'مشاوره',
        value: 'fa-solid fa-comment',
    },
    {
        label: 'پشتیبانی',
        value: 'fa-solid fa-headset',
    },
    {
        label: 'تنوع محصولی',
        value: 'fa-solid fa-cart-shopping',
    },
    {
        label: 'خرید حضوری',
        value: 'fa-solid fa-basket-shopping',
    },
    {
        label: 'خرید بدون واسطه',
        value: 'fa-solid fa-diamond-turn-right',
    },
    {
        label: 'دسترسی آسان',
        value: 'fa-solid fa-diamond-turn-right',
    },
    {
        label: 'کلاس‌های آنلاین',
        value: 'fa-solid fa-graduation-cap',
    },
    {
        label: 'بدون نیاز به نماد الکترونیک',
        value: 'fa-solid fa-check',
    },
    {
        label: 'حداقل کارمزد',
        value: 'fa-solid fa-calculator',
    },
    {
        label: 'ارسال رایگان',
        value: 'fa-solid fa-truck-fast',
    },
    {
        label: 'ارسال رایگان',
        value: 'fa-solid fa-truck',
    },
    {
        label: 'خرید اقساطی',
        value: 'fa-solid fa-dollar',
    },
]